import { render, staticRenderFns } from "./Hotpepper.vue?vue&type=template&id=4664b9ec"
import script from "./Hotpepper.vue?vue&type=script&lang=ts"
export * from "./Hotpepper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports